export const TABLE_SIZES = {
  fullName: {
    lg: true,
    md: true,
    sm: true,
    xs: 16
  },
  email: {
    lg: true,
    md: true,
    sm: true,
    xs: 16
  },
  phoneNumber: {
    lg: true,
    md: true,
    sm: true,
    xs: 16
  },
  nothing: {
    lg: 2,
    md: 1,
    sm: 0,
    xs: 0
  },
}
